//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';

export default {
    name: "selectCity",
    components: {},
    data() {
        return {
            items: [
                // {
                //     // 导航名称
                //     text: '长沙',
                //     // 导航节点额外类名
                //     className: 'my-class',
                //     // 该导航下所有的可选项
                //     children: [
                //         {
                //             // 名称
                //             text: '梅溪湖金茂湾',
                //             // id，作为匹配选中状态的标识符
                //             id: 1,
                //         },
                //         {
                //             text: '梅溪湖金茂府',
                //             id: 2
                //         }
                //     ]
                // },
                // {
                //     // 导航名称
                //     text: '江苏',
                //     // 导航节点额外类名
                //     className: 'my-class',
                //     // 该导航下所有的可选项
                //     children: [
                //         {
                //             // 名称
                //             text: '苏州',
                //             // id，作为匹配选中状态的标识符
                //             id: 3,
                //         },
                //         {
                //             text: '昆山',
                //             id: 4
                //         }
                //     ]
                // }
            ],
            activeId: 0,
            activeIndex: 0,
            cityList: [],
            projectList: [],
        };
    },
    methods: {
        onNavClick(index) {
            this.activeIndex = index;
            this.getProjects(this.items[index].id)
        },
        onItemClick(data) {
            // this.activeId = data.id;
            this.$router.push('/selectTimeline/' + data.id);
        },
        async getCities() {
            var vm = this;
            await this.$store.dispatch({
                type: 'city/getCityList'
            }).then(() => {
                this.cityList = this.$store.state.city.cityList;

                this.items = [];
                this.cityList.forEach((item, index) => {
                    this.items.push({
                        id: item.id,
                        text: item.name,
                        className: 'my-class',
                        children: []
                    })
                });
                this.getProjects(this.items[this.activeIndex].id)
                // console.log(this.items);
            })
        },
        async getProjects(cityId) {
            await this.$store.dispatch({
                type: 'project/getProjects',
                data: {cityId: cityId}
            }).then(() => {
                this.projectList = this.$store.state.project.projects;
                this.items[this.activeIndex].children = [];
                this.projectList.forEach((item, index) => {
                    this.items[this.activeIndex].children.push({
                        id: item.id,
                        text: item.name,
                    })
                })
            })
        }
    },
    created() {
        this.getCities()
    }
}


